module.exports = __webpack_public_path__ + "img/77.66bc260e.png";